export default __webpack_public_path__ + "static/media/Emojis16.1c687277.png";